module.exports = __webpack_public_path__ + "img/chk_payment.40d49593.svg";